<template>
    <el-dialog width="900px" customClass="dialog_detail_style" title="选择物料"
          :visible.sync="ishow"  
          @close="onCancel" v-dialogDrag>
        <matter-list class="contnet_box" ref="selectMatter" :selectedList="selectedRows" 
                     @getSelect="onSelectedRows" 
                     @cancelSelect="onUnselectRow">
        </matter-list>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onCancel">取 消</el-button>
            <el-button type="primary" @click="onConfirm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import matterList from "components/grid/FormGridPWindow.vue";
export default {
    components:{
        matterList
    },
    props:{
      show:{
          Type:Boolean,
          default(){
              return false
          }
      }
    },
    watch:{
       show(newVal,oldVal){
          this.ishow=newVal;
       }
    },
    data(){
        return {
           ishow:this.show,
           selectedRows:undefined,
        }
    },
    methods:{
      /**
       * 取消
       */
      onCancel() {
        let vm=this;
        vm.ishow = false;
        vm.$emit("onCloseWindow");
      },
      /**
       * 确认
       */
      onConfirm(){
          let vm=this;
          if(vm.selectedRows){
            vm.$emit("onConfirmSelected",vm.selectedRows);
            vm.ishow = false;
            vm.$emit("onCloseWindow");
          }else{
            vm.$message.error("没有选中行!");
          }
         
      },
      /**
       * 选择行
       */
      onSelectedRows(row){
         this.selectedRows=row;
      },
      /**
       * 反选行
       */
      onUnselectRow(){

      }
    }
}
</script>